// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"f0f14497","162":"f7da114c","171":"230bbc98","453":"07a6ab98"}[chunkId] + ".chunk.js";
};